import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useMemo, useReducer } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const InstallContext = /*#__PURE__*/React.createContext(null);
export function InstallationLockProvider(props) {
  function installationReducer(state, action) {
    switch (action.type) {
      case 'set_install_in_progress':
        return {
          installationInProgressAppKey: action.payload.appKey
        };
      case 'clear_install_in_progress':
        return {
          installationInProgressAppKey: null
        };
      case 'installation_success':
        if (props.onInstallSuccess) {
          props.onInstallSuccess({
            installedApp: action.payload.installedApp,
            enableDeprecatedInstallationsGQL: action.payload.enableDeprecatedInstallationsGQL
          });
        }
        return {
          installationInProgressAppKey: null
        };
      case 'initiate_direct_install':
        return _objectSpread(_objectSpread({}, state), {}, {
          directInstallInitiated: true
        });
      default:
        return state;
    }
  }
  const [installationState, dispatch] = useReducer(useMemo(() => installationReducer, [props.onInstallSuccess]), {
    installationInProgressAppKey: null
  });
  return /*#__PURE__*/_jsx(InstallContext.Provider, {
    value: {
      installationState,
      dispatch
    },
    children: props.children
  });
}
export function useInstallationLock() {
  const contextValue = React.useContext(InstallContext);
  if (!contextValue) {
    throw new Error('useInstallationLock must be used from within InstallationLockProvider');
  }
  return contextValue;
}